import { Component, effect, ElementRef, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonButton, IonSpinner } from '@ionic/angular/standalone';
import { AsyncState } from '@libs/core/lib/state/async-states';

@Component({
  selector: 'mtjr-submit-button',
  imports: [ReactiveFormsModule, IonSpinner, IonButton],
  template: `
    <ion-button
      [color]="color()"
      [fill]="fill()"
      [class]="class() + ' capitalize'"
      [expand]="expand()"
      [shape]="shape()"
      [type]="type()"
      [disabled]="state().type === 'loading' || disabled()"
    >
      <div class="flex items-center justify-center">
        @if (state().type === 'loading') {
          <ion-spinner class="me-2 h-4 w-4" />
        }
        <span>{{ label() }}</span>
      </div>
      <ng-content></ng-content>
    </ion-button>
  `,
})
export class VxSubmitButtonComponent {
  private elementRef = inject(ElementRef);
  label = input('Submit');
  color = input('primary');
  fill = input('solid');
  type = input('submit');
  shape = input('');
  expand = input('block');
  disabled = input(false);
  class = input('');
  state = input.required<AsyncState<unknown>>();

  constructor() {
    effect(() => {
      if (this.state().type === 'loading' || this.disabled()) {
        this.elementRef.nativeElement.style.pointerEvents = 'none';
      } else {
        this.elementRef.nativeElement.style.pointerEvents = 'auto';
      }
    });
  }
}
